import { Segment } from '@fixter/i18n';
import type { CmsAreaItem, CmsCarMakeItem, CmsCarModelItem } from '$cms/types';

interface PageCollectionItemsProp {
  readonly area?: Pick<CmsAreaItem, 'name'>;
  readonly carMake?: Pick<CmsCarMakeItem, 'name'>;
  readonly carModel?: Pick<CmsCarModelItem, 'name' | 'make'>;
}

/**
 * @TODO Translations! Need to translate these titles or preferably - manage them in the CMS with placeholders
 */
export function makePopularLinksListHeading(
  pageCollectionItems: PageCollectionItemsProp,
  segment?: Segment
): string {
  const { area, carMake, carModel } = pageCollectionItems;

  if (area && carMake) {
    return segment === Segment.Fixter_FR
      ? `Nos garages ${carMake.name} triés sur le volet et nos services disponibles dans la région de ${area.name}.`
      : `Our hand-picked ${carMake.name} garages and available services in the ${area.name} area.`;
  }
  if (area) {
    return segment === Segment.Fixter_FR
      ? `Nos garages triés sur le volet et nos services disponibles dans la région de ${area.name}.`
      : `Our hand-picked garages and available services in the ${area.name} area.`;
  }
  if (carModel) {
    return segment === Segment.Fixter_FR
      ? `Nous pouvons gérer chaque réparation ${carModel.make.name} ${carModel.name}`
      : `We can handle every ${carModel.make.name} ${carModel.name} repair - across the UK`;
  }
  if (carMake) {
    return segment === Segment.Fixter_FR
      ? `Nous pouvons gérer toutes les réparations ${carMake.name}`
      : `We can handle every ${carMake.name} repair - across the UK`;
  }
  return segment === Segment.Fixter_FR
    ? `Nous couvrons toutes les marques et tous les modèles`
    : 'We cover all makes and models - anywhere in the UK';
}
